import { Box, Breadcrumbs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Loading, useDataProvider, useTranslate } from 'react-admin';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Actions } from './Actions';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Success } from './Success';
import { validations } from './validations';

const CustomForm = ({ step, setStep }) => {
  const [teams, setTeams] = useState();
  const dataProvider = useDataProvider();

  const {
    reset,
    setValue,
    control,
    register,
    watch,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      teams_goals: [],
    },
  });
  const getTeams = async () => {
    let { data } = await dataProvider.getList('teams', {
      pagination: { page: 1, perPage: 100000 },
      sort: { field: 'name', order: 'ASC' },
      filter: {},
    });
    if (data && !teams) {
      setTeams(data);
    }
  };

  useEffect(() => {
    getTeams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function removeNumericFormat(formattedNumber) {
    if (!formattedNumber) return '';
    if (typeof formattedNumber !== 'string') return formattedNumber;
    let rawNumber = formattedNumber.replace(/(\.|,)/g, '');
    rawNumber = rawNumber.replace(/(\.|,)(?=\d{2}$)/, '.');
    return Number(rawNumber || 0);
  }

  const onSubmit = async values => {
    let body = {
      notes: removeNumericFormat(values?.notes),
      visits: removeNumericFormat(values?.visits),
      rfv: removeNumericFormat(values?.rfv),
      subscribers: removeNumericFormat(values?.subscribers),
      month: values?.month,
      teams_goals: values?.teams_goals,
    };
    body.teams_goals = body?.teams_goals?.map(i => ({
      team_id: i?.id,
      percentage_visits: Number(i?.percentage_visits || 0),
      percentage_notes: Number(i?.percentage_notes || 0),
      percentage_rfv: Number(i?.percentage_rfv == true ? body.rfv : 0),
      percentage_subscribers: Number(i?.percentage_subscribers || 0),
      point_visits: Number(i?.point_visits || 0),
      point_notes: Number(i?.point_notes || 0),
      point_rfv: Number(i?.point_rfv || 0),
      point_subscribers: Number(i?.point_subscribers || 0),
    }));
    try {
      let { data } = await dataProvider.create('goals', { data: body });
      if (data) {
        return true;
      }
      return false;
    } catch (e) {
      console.log(e);
    }
  };

  const handleReset = () => {
    setStep(1);
    reset();
    setTeams(prev =>
      prev?.map(i => ({
        id: i?.id,
        name: i?.name,
      }))
    );
  };

  useEffect(() => {
    if (Array.isArray(teams) && teams?.length > 0) {
      let new_teams = teams?.map(i => ({
        id: i?.id,
        name: i?.name,
        percentage_visits: undefined,
        percentage_notes: undefined,
        percentage_rfv: undefined,
        percentage_subscribers: undefined,
        point_visits: undefined,
        point_notes: undefined,
        point_rfv: undefined,
        point_subscribers: undefined,
      }));
      setValue('teams_goals', new_teams, {
        shouldDirty: true,
        shouldTouch: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teams]);

  if (!teams)
    return <Loading loadingSecondary="resources.goals.create.loading" />;

  return (
    <form>
      <Step1
        setTeams={setTeams}
        step={step}
        control={control}
        register={register}
        watch={watch}
        errors={errors}
      />
      <Step2
        step={step}
        control={control}
        register={register}
        watch={watch}
        errors={errors}
      />
      <Actions
        step={step}
        setStep={setStep}
        lastStep={2}
        handleLastStep={onSubmit}
        validations={validations}
        register={register}
        watch={watch}
        errors={errors}
        setError={setError}
        clearErrors={clearErrors}
      />
      {step == 3 ? <Success handleClick={handleReset} /> : null}
    </form>
  );
};

export const GoalsCreate = () => {
  const [step, setStep] = useState(1);
  const translate = useTranslate();

  return (
    <Box pt={2}>
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          color="inherit"
          sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '19px' }}
          component={Link}
          to="/goals"
        >
          {translate('resources.goals.name')}
        </Typography>
        <Typography
          color="textPrimary"
          sx={{ fontSize: '14px', fontWeight: '600', lineHeight: '19px' }}
        >
          {translate('resources.goals.create.title')}
        </Typography>
      </Breadcrumbs>
      <Box maxWidth={{ xs: '100%', sm: 850 }} mt={{ xs: 2 }} mx="auto">
        {step <= 2 ? (
          <Typography
            color="textPrimary"
            variant="h5"
            textAlign="center"
            sx={{ marginBottom: '48px' }}
          >
            {step === 1
              ? translate('resources.goals.create.titles.step1')
              : translate('resources.goals.create.titles.step2')}
          </Typography>
        ) : null}
        <CustomForm step={step} setStep={setStep} />
      </Box>
    </Box>
  );
};
